import { useQuery } from '@tanstack/react-query';

import {
  InspectionListEntity,
  IInspectionListEntity,
} from '../entities/InspectionListEntity';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

const getListInspection = async ({
  shipmentIds,
  makeRequest,
}: {
  shipmentIds: string[];
  makeRequest: any;
}): Promise<InspectionListEntity[]> => {
  const { data, error } = await makeRequest({
    path: '/shipments/security_inspections',
    method: 'POST',
    body: {
      shipment_ids: shipmentIds,
    },
  });

  if (error) throw new Error(error);

  return data.security_inspection_response.map(
    (inspection: IInspectionListEntity) =>
      InspectionListEntity.create(inspection)
  );
};

type QueryFnType = typeof getListInspection;

type UseGetListInspection = {
  config?: QueryConfig<QueryFnType>;
  shipmentIds: string[];
  enabled: boolean;
};

export const useGetListInspection = ({
  config,
  shipmentIds,
  enabled = true,
}: UseGetListInspection) => {
  const [, makeRequest] = useImperativeRequestWrapper('shipmentV3');

  return useQuery<ExtractFnReturnType<any>>({
    ...config,
    queryKey: ['inspectionList', shipmentIds],
    queryFn: () => getListInspection({ shipmentIds, makeRequest }),
    enabled: enabled && shipmentIds.length > 0,
  });
};
